import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { HeroNumberWidgets } from '@/modules/home';
import CreateOperationSelector from '@/modules/home/components/PageContent/Operations/CreateOperationSelector';
import { Button } from '@/shared/components/atoms';
import ValidateFieldModal from '@/shared/components/atoms/Demo/Modals/CreateFieldFirst';
import DemoCTA from '@/shared/components/atoms/Demo/Modals/DemoCTA';
import { roles } from '@/shared/constant/roles-and-permissions';
import { useAuth } from '@/shared/hooks/context/auth';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';
import useCheckPropertyFields from '@/shared/hooks/useCheckPropertyFields';

import Tractor from '~/images/shared/Tractor.svg';

const HeroNumbers = (): ReactElement => {
  const { t } = useTranslation('common');
  const { openModal } = useModal();
  const { user } = useAuth();

  const [selectedAsset] = useStore((store) => store?.asset);
  const [isDemoFarm] = useStore((store) => store?.isDemoFarm);
  const { hasFields } = useCheckPropertyFields();

  const isProductionOrFinanceManager =
    user?.userGroupId === roles.PRODUCTION_MANAGER ||
    user?.userGroupId === roles.FINANCIAL_MANAGER;

  const handleClick = () => {
    if (isDemoFarm) openModal(<DemoCTA />);
    else {
      if (!hasFields || (isProductionOrFinanceManager && hasFields))
        openModal(<ValidateFieldModal />);
      else
        openModal(<CreateOperationSelector />, {
          title: t('create-an-operation'),
          containerClassName: 'bg-background-neutral-100',
        });
    }
  };

  return (
    <section className='flex flex-col gap-7'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-2 text-20 text-primary-default'>
          <Tractor width='24' height='24' />
          <h3 className='font-bold capitalize leading-none'>
            {t('operations')}
          </h3>
        </div>
        {selectedAsset?.entityTypeId === 2 && (
          <Button onClick={handleClick} size='lg'>
            {t('create-an-operation')}
          </Button>
        )}
      </div>
      <HeroNumberWidgets />
    </section>
  );
};
export { HeroNumbers };
